class Monitoring.Views.SocialContentsPreview extends Backbone.View

  template: JST["backbone/templates/monitoring/dashboards/social_contents_preview"]

  initialize: (options) ->
    @vueSocialContentsPreview = new VueInBackbone.VueApp('social-contents-preview',
      {
        searchQuery: null,
        show: false,
        permissions: options.submodesPermissions || { social_contents_analysis: false },
        theme: 'blue'
      }
    )
    @vueSocialContentsPreview.on('hide', @hide)
    @vueSocialContentsPreview.on('open-in-new-session', @openNewSession)

  render: ->
    @$el.html(@template)
    @$el.find('.social-contents-preview__container').html(@vueSocialContentsPreview.el)
    @vueSocialContentsPreview.render()

    @

  showWith: (searchQuery)->
    @searchQuery = searchQuery
    @vueSocialContentsPreview.update({ searchQuery: searchQuery, show: true })
    @resizeCharts()

  hide: =>
    @vueSocialContentsPreview.update({ show: false })
    @resizeCharts()

  openNewSession: =>
    query = @searchQuery.deepCopy()
    @eventAggregator.trigger('clickOnCloneDashboard', query)

  resizeCharts: =>
    setTimeout (() =>
      @trigger('masonry')
    ), 100

  destroy: ->
    @remove()

  remove: ->
    @vueSocialContentsPreview.remove()
    super()
